import React from 'react';
import Collection from 'collections';
import PresentNotificationList from 'components/NotificationList';
import Fetcher from 'components/Fetcher';

const notifications = new Collection({
    name: 'notifications',
    listUrl: 'user/notifications/',
});

const FetchNotificationList = ({ manager, title }) => (
    <Fetcher
        fetch={manager.actions.replaceItems}
        render={() => (
            <PresentNotificationList
                notifications={manager.getItems()} title={title}
            />
        )}
    />
);

export const NotificationList = notifications.connect()(FetchNotificationList);

export default notifications;
